import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";
import { I18n } from "aws-amplify/utils";

function ConfirmationDialog({ open, onClose, onSave, onCancel, type }) {
  const handleSave = () => {
    onSave();
    onClose();
  };

  return (
    <Dialog fullWidth maxWidth="sm" open={open} onClose={onClose}>
      <DialogTitle>{I18n.get("Action confirmation")}</DialogTitle>
      <DialogContent>
        { type === "add" ?
          I18n.get("Are you sure you want to add a new closure rule?")
          : I18n.get("Are you sure you want to edit this closure rule?")
        }
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel}>
          {I18n.get("Cancel")}
        </Button>
        <Button
          onClick={handleSave}
          color="error"
        >
          {I18n.get("Confirm")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ConfirmationDialog;
